import { render } from "./Abscencemodal.vue?vue&type=template&id=bce260dc&scoped=true"
import script from "./Abscencemodal.vue?vue&type=script&lang=js"
export * from "./Abscencemodal.vue?vue&type=script&lang=js"

import "./Abscencemodal.vue?vue&type=style&index=0&id=bce260dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce260dc"]])

export default __exports__